import http from './http-service'
import config from '../config/constant'
import { store } from '../store'
import {
  DASHBOARD_CONST_MENUS,
  OTHER_MENUS,
  roleDisplayIcons,
  roleDisplayDashboardIcons,
  userAccessLink,
  titleDesc
} from '../pages/Layout/menu-names'
import { SET_SUB_ROLE_ACCESS_DETAILS } from '../store/constants'

const assetsAndLiabilities = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.portfolio.assetsAndLiabilities, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getMenuDetails = async (accessKey) => {
  try {
    const { auth, app } = store.getState()
    const { menuDetails, roleAccessDetails } = app
    let filterRoleDetails = menuDetails.filter((ele) =>
      roleAccessDetails[accessKey || 'I'].includes(ele.screenCode),
    )
    // console.log(filterRoleDetails)
    store.dispatch({
      type: SET_SUB_ROLE_ACCESS_DETAILS,
      payload: filterRoleDetails,
    })
    const dynamicLinks = []
    const data = filterRoleDetails.filter(
      (ele) => ele.isParent === 'Y' && ele.parent !== 'INSTANTFT',
    )
    data.forEach((element) => {
      dynamicLinks.push({
        desc: 'Description here',
        icon: roleDisplayIcons[element.parent],
        link: userAccessLink[element.parent] || 'dashboard',
        title: titleDesc[element.parent],
        dashIcon: roleDisplayDashboardIcons[element.parent],
      })
    })

    let OTHER_MENUS_LIST = OTHER_MENUS.filter((e) => app.menuList['DASHBOARD'][e.key])
    let DASHBOARD_MENU_LIST = DASHBOARD_CONST_MENUS.filter((e) => app.menuList["DASHBOARD"][e.key])
    const menuOptions = [...DASHBOARD_MENU_LIST, ...dynamicLinks, ...OTHER_MENUS_LIST]
    // console.log(menuOptions)
    return { status: 200, data: menuOptions }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getSubMenus = async (parentKey) => {
  try {
    const { app } = store.getState()
    const { subRoleAccessDetails } = app
    const subOptions = subRoleAccessDetails.filter(
      (ele) => ele.parent === parentKey && ele.isParent !== 'Y',
    )
    return { status: 200, data: subOptions }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getAccountSubMenus = async (parentKey) => {
  try {
    const { app } = store.getState()
    const { subRoleAccessDetails } = app
    const accSubOptions = subRoleAccessDetails.filter(
      (ele) => ele.parent === 'ACCOUNTS' && ele.isParent !== 'Y' && ele.screenCode !== 'SACCOUNTS',
    )
    const requestOptions = subRoleAccessDetails.filter(
      (ele) => ele.parent === 'REQUESTS' && ele.isParent === 'Y',
    )

    const quickPayOption = subRoleAccessDetails.filter(
      (ele) => ele.parent === 'INSTANTFT' && ele.isParent === 'Y',
    )

    const paymentOption = subRoleAccessDetails.filter(
      (ele) => ele.parent === 'BILLPAYMENT' && ele.isParent === 'Y',
    )

    const beneOption = subRoleAccessDetails.filter(
      (ele) => ele.parent === 'BENE' && ele.isParent === 'Y',
    )

    return {
      status: 200,
      data: [
        ...paymentOption,
        ...quickPayOption,
        ...requestOptions,
        ...beneOption,
        ...accSubOptions,
      ],
    }
  } catch (err) {
    return Promise.reject(err)
  }
}


const getOffers = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "OFFERS"
    }
    const response = await http.post(config.userActions.getOffers, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getApprovalNotification = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: "REGISTUSER"
    }
    const response = await http.post(config.dahsboard.getAllCounts, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const DashboardService = {
  assetsAndLiabilities,
  getMenuDetails,
  getSubMenus,
  getAccountSubMenus,
  getOffers,
  getApprovalNotification,
}

export default DashboardService
